import axios from 'axios';

let cachedRegion = null;

export const detectRegion = async () => {
    if (cachedRegion) return cachedRegion;

    try {
        // Using ipwho.is which has better CORS support for client-side requests
        const response = await axios.get('https://ipwho.is/', { timeout: 3000 });
        const country = response.data.country_code; // e.g., 'IN', 'US', 'GB'
        const continent = response.data.continent_code;

        if (country === 'IN' || continent === 'AS') cachedRegion = 'Asia';
        else if (country === 'US' || country === 'CA') cachedRegion = 'US';
        else if (continent === 'EU') cachedRegion = 'Europe';
        else cachedRegion = 'US';

        return cachedRegion;
    } catch (error) {
        // Silent fallback to avoid console noise in dev
        console.warn('Region detection timed out or failed, falling back to US');
        return 'US';
    }
};

export const getCurrencyInfo = (region) => {
    switch (region) {
        case 'Asia':
            return { symbol: '₹', code: 'INR', price: 1, stripePriceId: 'price_1SvajIGag87QybiaL3GfAnr4' };
        case 'US':
            return { symbol: '$', code: 'USD', price: 1, stripePriceId: 'price_1Svaj3Gag87QybiaM5zSF8lZ' };
        case 'Europe':
            return { symbol: '£', code: 'GBP', price: 1, stripePriceId: 'price_1SvafAGag87QybiabIWYC41L' };
        default:
            return { symbol: '$', code: 'USD', price: 1, stripePriceId: 'price_1Svaj3Gag87QybiaM5zSF8lZ' };
    }
};
